import { z } from "zod";
import { ProductAddPayloadSchema, ProductSyncPayloadSchema } from "../hooks/productFetchHooks";
import { apiClient } from "../commonApis/apiClient";

export type Product = {
    id: string;
    title: string;
}

export type ProductSyncPayload = z.infer<typeof ProductSyncPayloadSchema>;
export type ProductAddPayload = z.infer<typeof ProductAddPayloadSchema>;

export const productApi = {
    productSync: (payload: ProductSyncPayload, page: number, limit: number) =>
        apiClient.post<Product>(`/api/product-item/sync-products?page=${page}&limit=${limit}`, payload),

    productAdd: (payload: ProductAddPayload | FormData, isFormData: boolean = false) =>
        apiClient.post<Product>("/api/product-item/add-products", payload, isFormData),
}